import Box from '@amzn/awsui-components-react/polaris/box';
import Link from '@amzn/awsui-components-react/polaris/link';
import { CopyButton, useLazyRequest } from '@amzn/event-engine-js-utils';
import { AWSError } from 'aws-sdk/lib/error';
import { useNotification } from 'hooks';
import React, { FC, useCallback, useEffect } from 'react';
import { EEEvents, ErrorMessage } from 'services';
import { i18nStrings } from 'utils/constants';

import { routePaths, routes } from '../../../constants';

export interface TeamLoginLinkProps {
    participantId: string;
    deploymentRegions?: string[];
}

const TeamLoginLink: FC<TeamLoginLinkProps> = ({
    participantId,
    deploymentRegions,
}) => {
    const [
        getParticipantTeamLoginLink,
        { isError: participantTeamLoginLinkError },
    ] = useLazyRequest<typeof EEEvents.getParticipantTeamLoginLink, AWSError>(
        EEEvents.getParticipantTeamLoginLink,
        {}
    );
    const getTeamLoginLink = useCallback(
        async () =>
            await getParticipantTeamLoginLink(participantId).then(
                (res) => res?.loginLink || ''
            ),
        []
    );
    const { showNotification, clearNotification } = useNotification();

    useEffect(() => {
        participantTeamLoginLinkError &&
            showNotification(
                ErrorMessage.getMessage(participantTeamLoginLinkError),
                { type: 'error' }
            );
    }, [participantTeamLoginLinkError]);

    useEffect(() => {
        return () => {
            clearNotification();
        };
    }, []);

    return (
        <span>
            <Box margin={{ right: 'xxs' }} display="inline">
                <Link
                    href={`${routes.events}/${routePaths.accountLogin}`}
                    target="_blank">
                    {i18nStrings.event.openAWSConsole}
                    {deploymentRegions?.length ? (
                        <>
                            <br />({deploymentRegions[0]})
                        </>
                    ) : (
                        ''
                    )}
                </Link>
            </Box>
            <CopyButton
                deferredContent={getTeamLoginLink}
                variant="inline-icon"
            />
        </span>
    );
};

export default TeamLoginLink;
